import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Observable, of } from 'rxjs';

@Injectable()
export class AuthRouter implements CanActivate, CanActivateChild {
  constructor(private authService: AuthService) {
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    // const token = route.queryParams.token;
    // if (token) {
    //   const authenResponse: AuthenResponse = {
    //     access_token: token,
    //     refresh_token: route.queryParams.refresh_token,
    //     token_type: 'router',
    //     expires_in: 1
    //   };
    //   this.authService.setupToken(authenResponse);
    //   this.authService.gotoPage();
    //   return Observable.of(true);
    // }
    if(this.authService.getAccessToken() && this.authService.isValidToken()) {
      return of(true);
    } else {
      this.authService.logout();
      return of(false);
    }
    // Get user login
    // this.authService.getUserLogin().subscribe(user => {
    //   let isValid = false;
    //   if (user && user.authorities.length > 0) {
    //     for (const role of user.authorities) {
    //       if (route.data && route.data.roles && route.data.roles.indexOf(role) > -1) {
    //         isValid = true;
    //         break;
    //       }
    //     }
    //   }
    //   if (!isValid) {
    //     this.authService.logout();
    //   }
    //   return Observable.of(isValid);
    // });
    // return Observable.of(true);
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

    // if (childRoute.data.permission) {
    //   // AuthService.redirectUrl = state.url;
    //   this.authService.getUserLogin().subscribe(user => {
    //     let isValid = false;
    //     if (user && user.authorities.length > 0) {
    //       for (const role of user.authorities) {
    //         if (_.size(screenMatrix[role][childRoute.data.permission]) > 0) {
    //           isValid = true;
    //           break;
    //         }
    //       }
    //     }
    //     if (!isValid) {
    //       this.authService.gotoPage(403);
    //     }
    //     return Observable.of(isValid);
    //   });
    // }
    return Observable.of(true);
  }
}
